import { AppBanner } from "./Dashboard.styles";
import mobilebanner from "../../../../assets/pages/landing/dashboard/mobilebanner.png";

const MobileAppCard = () => {
  return (
    <AppBanner>
      <img
        src={mobilebanner}
        alt="Download the NMDFC app"
        className="mobile-app-banner-image"
      />
    </AppBanner>
  );
};

export default MobileAppCard;
